import React from 'react'
import styles from './dashboard.module.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import constant from '../../constant';
const FreshJobPostBanner = () => {
    return (
        <React.Fragment>
            <div className='col-md-6'>
                <div className={`${styles['templates-card']} mb-100 h-100`}>
                    <h3>Manually Post a Job</h3>
                    <p>Post a job manually as per your requirements, get more control at fingertips.</p>
                    <a href={constant.component.postOppurtunity.url} target='_blank'>

                        <div className={`${styles['temp-two']} card-body d-flex justify-content-center align-items-center border rounded bg-light`}>
                            <FontAwesomeIcon icon={faPlus} />
                        </div>
                    </a>

                </div>
            </div>
        </React.Fragment>
    )
}

export default FreshJobPostBanner